export const DEFAULT_PROFILE_NAME = 'VPN Shurik';

export function buildSingboxImportUrl(
  subscriptionUrl,
  profileName = DEFAULT_PROFILE_NAME
) {
  if (!subscriptionUrl) {
    return null;
  }
  return (
    `sing-box://import-remote-profile?url=${encodeURIComponent(subscriptionUrl)}` +
    `#${encodeURIComponent(profileName)}`
  );
}
